import type { TrackEvent } from '../@types/Tracking';
import useProfile from '../data/profile/useProfile';
import useAuth from '../hooks/useAuth';
import trackerHub from './trackerHub';
import trackWithUser from './trackerWithUser';
import trackWithCommonData from './trackWithCommonData';

const useTracking = (): ((data: TrackEvent) => void) => {
  const { decodedToken } = useAuth();
  const [profile] = useProfile();

  const track = (data: TrackEvent) =>
    trackerHub(trackWithUser(decodedToken, profile, trackWithCommonData(data)), decodedToken);
  return track;
};

export default useTracking;
